import { getCookie, deleteCookie, buildRequest } from "./auth.js";
import UnauthorisedError from '../errors/UnauthorisedError.js';

export async function fetchDistributorAccount() {
    const url = `/Distributor/GetAccountProfile`;

    try {
        const response = await buildRequest(url);

        if (!response.ok) {

            if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch account: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchDistributorEyeTickets(account, page, pageSize, status = null, searchValue = null, raisedBy = null) {
    let url = `/Distributor/GetDistributorEyeTicketsHistory/${encodeURIComponent(account)}/${encodeURIComponent(pageSize)}/${encodeURIComponent(page)}`;

    if (status || searchValue || raisedBy) {
        url += '?';

        if (status) {
            url += `cStatus=${encodeURIComponent(status)}`;
        }

        if (searchValue) {
            if (status) {
                url += '&';
            }
            url += `cSearchValue=${encodeURIComponent(searchValue)}`;
        }

        if (raisedBy) {
            if (status || searchValue) {
                url += '&';
            }
            url += `cRaisedBy=${encodeURIComponent(raisedBy)}`;
        }
    }

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No EyeTickets found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch EyeTickets: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchDistributorEyeTicketsAwaitingConfirmation(account, page, pageSize) {
    let url = `/Distributor/GetOrdersAwaitingAuthorisation/${encodeURIComponent(pageSize)}/${encodeURIComponent(page)}`;

    if (account) {
        url += '?';

        if (account) {
            url += `cAccountID=${encodeURIComponent(account)}`;
        }
    }

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No EyeTickets found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch EyeTickets: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function authoriseOrder(order) {
    const url = `/Distributor/OrderAuthorisationsProcessing`;

    try {
        const response = await buildRequest(url, 'POST', order);
        const text = await response.text();
        try {
            const data = JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to authorise Order: ${response.status} ${response.statusText} | ${data.detail || text}`);
                }
            }
            return data;
        } catch (err) {
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to authorise Order: ${response.status} ${response.statusText} | ${text}`);
                }
            }
        }
    } catch (error) {
        throw new Error(error.message);
    }
}